import React from 'react';
import { Heading, Box } from '@hover/blueprint';
import SignUpCTAForm from '../signup-cta-form';

const DownloadAppModalMobile: React.FC = () => (
  <Box d={{ base: 'flex', tablet: 'none' }} flexDir="column" py={800}>
    <Heading size={600} isLight textAlign="center">
      Build your better tomorrow today
    </Heading>
    <Heading size={300} isDisplay marginBottom={800} textAlign="center">
      HOVER makes home improvement simpler, faster and more collaborative for
      homeowners and pros.
    </Heading>
    <SignUpCTAForm
      inputColor="brandNavy.600"
      inputBackground="neutral.100"
      contentColor="neutral.600"
      linkColorScheme="primary"
    />
  </Box>
);

export default DownloadAppModalMobile;
